import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    id: Number,
    interval: { type: Number, default: 3000 }
  }

  static targets = ['message', 'continueLink', 'continueBox']

  connect () {
    this.poll()
  }

  poll () {
    fetch(`/a/credit_grant_csvs/${this.idValue}/status`)
      .then(response => response.json())
      .then(data => {
        if (data.done) {
          this.continueLinkTarget.href = '/a/credit_grants'
          this.continueLinkTarget.classList.remove('disabled')
          this.continueBoxTarget.classList.remove('d-none')
          this.messageTarget.classList.add('d-none')
        } else {
          setTimeout(() => this.poll(), this.intervalValue)
        }
      })
  }
}
